import { Checkbox, CircularProgress, Divider, List } from '@material-ui/core';
import React from 'react';
import { localized } from '../../../../state/i18n/i18n';
import { GetColorByIndex } from '../../../../utilities/colors';
import DeviceMenuItem from './device-menu-item';
import './device-menu.scss';

export default ({devices, setDevices}) => {
  const selectAllDevices = (e) => {
    const selected = e.target.checked;
    const newDevices = devices.map((device) => ({
      ...device,
      selected,
    }));
    setDevices(newDevices);
  };

  const selectedAll = Array.isArray(devices) && devices.length && devices.every((device) => device.selected);
  const showDeviceMenuTopContainer = () => (
    <div className={'topContainer devicesTableTopContainer'}>
      <div className="width100">
        <div className="boldText">{localized('Devices')}</div>
        <div className="availableDevices">{localized('AvailableDevices')}</div>
      </div>
    </div>
  );

  const mapDevices = () => {
    if (!Array.isArray(devices)) {
      return <div className="emptyMessageSettings">{localized('LoadingDevices')}</div>;
    } else {
      if (devices.length > 0) {
        return devices.map(showDeviceMenuItems);
      }
      return <div className="emptyMessageSettings">{localized('NoDevices')}</div>;
    }
  };

  const menuItemClick = (deviceId) => {
    if (Array.isArray(devices)) {
      const newDevices = [...devices];
      const selectedDevice = newDevices.find((device) => device.deviceId === deviceId);
      selectedDevice.selected = !selectedDevice.selected;
      setDevices(newDevices);
    }
  };

  const showDeviceMenuItems = (d, index) => (
    <DeviceMenuItem
      onMenuItemClicked={menuItemClick}
      checkBoxColor={GetColorByIndex(index)}
      selected={d.selected}
      name={d.deviceId}
      active={d.active}
      key={d.deviceId}
      identifier={d.deviceId}
      calibrationFactor={d.calibrationFactor}
    />
  );

  return (
    <div>
      {showDeviceMenuTopContainer()}
      {devices !== null && (
        <>
          <Divider />
          <div className="chooseAllOrDismissContainer">
            <div className="chooseAllOrDismiss">{localized('ChooseOrDismissAll')}</div>
            <Checkbox onClick={selectAllDevices} color={'primary'} className="checkBoxStyle" checked={selectedAll} />
          </div>
        </>
      )}
      <Divider />
      <div className="deviceOverflow">
        {<List className="devicesSelect">{mapDevices()}</List>}

        {devices === null && <CircularProgress className="spinnerDevice" />}
      </div>
    </div>
  );
};
